import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

export const useQueueOverloadedPaywallModalStore = createModalStore<{ pricingEntryPoint?: PricingEntryPoint }>({
  pricingEntryPoint: 'unattributed_paywall',
});
